import { useView } from '@10000/react'
import { Table } from './table'
import { country as countries, industries } from '../../../lookups'

export const TenantTable = () => {
  const { company: { city, country, industry } } = useView('tenant')

  const columns = [
    { key: 'industry', name: 'Industry' },
    { key: 'country', name: 'Country' },
    { key: 'city', name: 'City' }
  ]

  const rows = [{
    industry: industries[industry]?.name,
    country: countries?.name[country],
    city
  }]

  return (
    <Table
      title="Teams"
      rows={rows}
      columns={columns}
      defaultSortColumn="industry"
    />
  )
}